// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M14.7211 22.6609C19.1678 21.5294 22.5327 17.6889 22.9552 13.0001H17.974C17.7884 16.5472 16.6179 19.8471 14.7211 22.6609Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22.9552 11.0001C22.5326 6.30957 19.1656 2.46808 14.7166 1.33799C16.6152 4.15179 17.787 7.45222 17.9738 11.0001H22.9552Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M9.28355 1.33799C4.83458 2.46808 1.46758 6.30957 1.04492 11.0001H6.02641C6.21312 7.45222 7.38502 4.15178 9.28355 1.33799Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M1.04493 13.0001C1.4675 17.6889 4.83239 21.5294 9.27912 22.6609C7.38225 19.8471 6.21181 16.5472 6.02613 13.0001H1.04493Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12.0001 22.962C9.69262 20.1775 8.24832 16.7407 8.02922 13.0001H15.971C15.7518 16.7407 14.3075 20.1775 12.0001 22.962Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12.0001 1.04346C14.3065 3.82658 15.7505 7.26153 15.9706 11.0001H8.02953C8.24969 7.26153 9.69371 3.82658 12.0001 1.04346Z"}}]};

const InternetFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'internet-filled',
    ref,
    icon: element,
  },
));

InternetFilledIcon.displayName = 'InternetFilledIcon';

export default InternetFilledIcon;
